// Copyright ©️ 2026 eVolve MEP, LLC

import type { EntityStatusProps } from 'components/Mantine/EntityStatusBadge';
import type { CustomStatusEntityName } from 'components/Mantine/StatusEditor/types';
import { useCustomStatuses } from 'components/Mantine/StatusEditor/useCustomStatuses';
import { StatusPoint } from 'components/Mantine/StatusPoint';
import { isNil } from 'helpers/isNotNil';

/**
 * Small colored dot to indicate a state or custom status.
 */
export const EntityStatusPoint = <T extends CustomStatusEntityName>({
  customStatusEntityName,
  stateName,
  statusId,
  ...props
}: EntityStatusProps<T> & {
  size?: number;
}) => {
  const { getLabelAndColor } = useCustomStatuses(customStatusEntityName);
  if (isNil(stateName)) return null;
  const { color, label: tooltip } = getLabelAndColor(stateName, statusId);
  return <StatusPoint color={color} tooltip={tooltip} {...props} />;
};
